export { default as AdvDetailedTooltip } from './AdvDetailedTooltip'
